// 判斷當前系統環境開發or線上
var isPro = process.env.NODE_ENV === 'production'
var ApiRoot = ''

const base = {
  NukApi: isPro ? ApiRoot : '/apis',
  LineApi: isPro ? ApiRoot : '/line',
  CardApi: isPro ? ApiRoot : '/card'
}

export default base
